import { styled, Grid as MuiGrid } from "@mui/material";
import { supernova, white } from "../../../../assets/styles/colors";

const PREFIX = "SystemMessagesActionsStyles";
export const classes = {
  saveButton: `${PREFIX}-saveButton`,
  markedButton: `${PREFIX}-markedButton`
};

export const Grid = styled(MuiGrid)(() => ({
  [`& .${classes.saveButton}`]: {
    color: white
  },
  [`& .${classes.markedButton}`]: {
    backgroundColor: supernova
  }
}));
